<template>
  <Header title="Signature Series Ultrack ELD" />
  <Container class="-mb-6">
    <div class="text-center">
      <h2 class="mt-1 md:text-5xl">
        Introducing our newest
        <span class="text-accent-light">innovation</span>
      </h2>
    </div>
  </Container>

  <!-- Signature Series ULTRACK ELD -->
  <Split
    title="Signature Series Ultrack ELD"
    description="The Ministry of Transportation has told us about the mandated June 12 date for Electronic Logging Devices. But there’s something you may not have known.

When the Minister of Transport announced that all fleets had to comply with the installation of ELD’s, other companies went immediately to develop Android-based systems.

Big Mistake.

As you know, Android/Google can expose your data–fuel purchases, routes, client locations and more – to be scrutinized by others."
  >
    <img src="@/assets/product.jpg" />
    />
  </Split>

  <Split
    :flip="true"
    title="Ultrack ELD alone uses Windows 10 Enterprise Edition to store your data."
    description="Rest easy knowing we offer:
• Seamless, secure interactions
• Best in class inspection reports 
• User friendly
• Larger screens and heavy duty Arkon Display Mounts
"
  >
    <img src="@/assets/UltrackELDscreen.jpg" />
  </Split>
</template>

<script>
import Split from "../../components/layouts/Split.vue";
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";
const products = [
  {
    name: "U100",
    role: "Battery‐powered Asset Tracking Device",
    imageUrl: "http://ultrack.ca/media/Ultrack/site-images/u100.png?ext=.png",
    bio: "Whether you are monitoring shipments on a truck or railroad car, the location of construction trailer, a shipping container, air conditioning compressor, pallet of high‐value products or any other valuable asset, the U100 is the right solution for you.",
  },
  {
    name: "U200",
    role: "Solar Powered Asset Tracking Device ",
    imageUrl:
      "http://ultrack.ca/media/Ultrack/site-images/gps-tracking-device-solar-power1.png?ext=.png",
    bio: "The U200 solar powered GPS tracker is great for dry-vans, construction/equipment/utility trailers and other assets that are more stationary then moving.",
  },
];
export default {
  components: {
    Container,
    Header,
    Split,
  },
};
</script>
